module.exports = __webpack_public_path__ + "static/media/29-c-piano.87f33550.svg";